import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import config from '../utils/apiUrl';

const storedUser = localStorage.getItem('adminUser');
const initialState = storedUser
  ? JSON.parse(storedUser)
  : {
      isAuthenticated: false,
      user: null,
      error: null,
      loading: false,
    };

export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {

      const response = await fetch(`${config.apiUrl}/signin/account/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password,
          companyAdmin: true, // Explicitly request company admin access
        }),
      });

      const data = await response.json();

      if (!data.success) {
        return rejectWithValue(data.message || 'Datos incorrectos.');
      }

      // Manual check for adminCompany being truthy
      const hasCompanyAccess = Boolean(data.adminCompany);
      if (!hasCompanyAccess) {
        return rejectWithValue(
          'No tienes permiso para acceder a esta área de administración de empresa.'
        );
      }

      return data;
    } catch (error) {
      console.error('Login error:', error);
      return rejectWithValue('Error al iniciar sesión.');
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
      localStorage.removeItem('adminUser');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.user = {
          userId: action.payload.userId,
          token: action.payload.token,
          adminCompany: true, // Explicitly set to true for company admin access
        };
        state.error = null;
        state.loading = false;

        localStorage.setItem(
          'adminUser',
          JSON.stringify({
            isAuthenticated: true,
            user: {
              userId: action.payload.userId,
              token: action.payload.token,
              adminCompany: true,
            },
            error: null,
            loading: false,
          })
        );
      })
      .addCase(login.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.user = null;
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
